<template>
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15 8H18.5C19.1566 8 19.8068 8.12933 20.4134 8.3806C21.02 8.63188 21.5712 9.00017 22.0355 9.46447C22.4998 9.92876 22.8681 10.48 23.1194 11.0866C23.3707 11.6932 23.5 12.3434 23.5 13C23.5 13.6566 23.3707 14.3068 23.1194 14.9134C22.8681 15.52 22.4998 16.0712 22.0355 16.5355C21.5712 16.9998 21.02 17.3681 20.4134 17.6194C19.8068 17.8707 19.1566 18 18.5 18H15.5M10 18H6.5C5.84339 18 5.19321 17.8707 4.58658 17.6194C3.97995 17.3681 3.42876 16.9998 2.96447 16.5355C2.02678 15.5979 1.5 14.3261 1.5 13C1.5 11.6739 2.02678 10.4021 2.96447 9.46447C3.90215 8.52678 5.17392 8 6.5 8H9.5"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.1149 21.5355L14.5793 18L18.1149 14.4645"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.53553 4.46447L10.0711 8L6.53553 11.5355"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
